import React from 'react';

export const dashboardRoute = '/wms/dashboard';

export function Dashboard(props) {
	return <div>test</div>;
}
